import api from './api';

export const kanbanService = {
  // Pobierz wszystkie listy Kanban z kartami
  getLists: async () => {
    const response = await api.get('/kanban/lists');
    return response.data;
  },

  // Utwórz nową listę Kanban
  createList: async (listData) => {
    const response = await api.post('/kanban/lists', listData);
    return response.data;
  },

  // Zaktualizuj listę Kanban
  updateList: async (id, listData) => {
    const response = await api.put(`/kanban/lists/${id}`, listData);
    return response.data;
  },

  // Usuń listę Kanban
  deleteList: async (id) => {
    const response = await api.delete(`/kanban/lists/${id}`);
    return response.data;
  },

  // Utwórz nową kartę Kanban
  createCard: async (cardData) => {
    const response = await api.post('/kanban/cards', cardData);
    return response.data;
  },

  // Zaktualizuj kartę Kanban
  updateCard: async (id, cardData) => {
    const response = await api.put(`/kanban/cards/${id}`, cardData);
    return response.data;
  },

  // Usuń kartę Kanban
  deleteCard: async (id) => {
    const response = await api.delete(`/kanban/cards/${id}`);
    return response.data;
  }
};

